import { invoke } from '@shared/easyfy.decorators';
import Splide from '@splidejs/splide';

namespace Easyfy.Components {
  @invoke
  class ProductListComponent {
    constructor() {

    }

    onInit() {
      document.querySelectorAll('[data-container="articlelist-scroll"]').forEach(list => {
        list.classList.add("splide");
        let perView: number = parseInt(list.attributes['data-perview']?.value);
        if (!perView) {
          perView = 5;
        }
        const slider = new Splide(list as HTMLElement, {
          type: 'loop',
          perPage: perView,
          speed: 500,
          dragMinThreshold: 20,
          flickMaxPages: 1,
          flickPower: 100,
          snap: false,
          arrows: true,
          gap: 40,
          breakpoints: {
            1100: {
              perPage: 2,
              arrows: true,
              pagination: false
            },
            760: {
              perPage: 1,
              gap: 20,
              padding: {
                left: 0,
                right: 40
              }
            }
          }
        }).mount();
      });
    }
  }
}